import { render, staticRenderFns } from "./QC-user.vue?vue&type=template&id=918ec4e4&"
import script from "./QC-user.vue?vue&type=script&lang=js&"
export * from "./QC-user.vue?vue&type=script&lang=js&"
import style0 from "./QC-user.vue?vue&type=style&index=0&id=918ec4e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports